import React from 'react';

import CollectionCard from 'components/widgets/CardView/Collection/CollectionCard/CollectionCard';

import { CardSkeleton } from '../../../../CardView/CardSkeleton/CardSkeleton';
import { NumberIcon } from '../NumberIcon/NumberIcon';

import styles from './TopCardContainer.module.scss';

function TopCardContainer({ index, data, itemWidth, imageHeight }: any) {
  if (!data?.id) {
    return <CardSkeleton height={imageHeight} width={itemWidth} />;
  }

  return <>
    <NumberIcon className={styles.number} index={index} imageHeight={imageHeight}/>
    <CollectionCard hasNoDirectPlayback imageHeight={imageHeight} itemWidth={itemWidth} item={data} />
  </>
}

export default React.memo(TopCardContainer);
